module.exports = [{"type":"title","text":"2025-10-09"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"關於BingX全量啟用現貨賬戶功能的公告：https://bingx.com/zh-tc/support/articles/13672873913359"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-10-09.json
// module id = 8erW
// module chunks = 3